import { render, staticRenderFns } from "./View-Order.vue?vue&type=template&id=6cdc6183&scoped=true"
import script from "./View-Order.vue?vue&type=script&lang=js"
export * from "./View-Order.vue?vue&type=script&lang=js"
import style0 from "./View-Order.vue?vue&type=style&index=0&id=6cdc6183&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc6183",
  null
  
)

export default component.exports